import compose from 'lodash/fp/compose';

import { canAdd, canUpdate, selectable } from '../plugins';
import questionsApi from '../../firebase/questions';
import PluggableModule from '../pluggable';

const questions = new PluggableModule('question');

questions.addMutationTypes([
  'QUESTION_EDITOR_SET',
  'QUESTION_REPLACE_SELECTED_DEF'
]);

function getOwnerData(state, owner) {
  const path = `${owner}/${state[owner].selected.id}`;
  let addToOwnerMutation,
    addLocation = path;
  switch (owner) {
    case 'tests':
      addToOwnerMutation = questions.con.TEST_ADD_CHILD_REF_NAMESPACED;
      break;
    case 'challenges':
      addLocation = `${path}/data/details`;
      addToOwnerMutation = questions.con.CHALLENGE_ADD_CHILD_REF_NAMESPACED;
      break;
    default:
      throw new Error(`Invalid owner type: ${owner} for question!`);
  }

  return { path, addToOwnerMutation, addLocation };
}

questions.extend({
  namespaced: true,
  state: {
    questionId: null,
    questionType: null
  },
  mutations: {
    [questions.con.QUESTION_EDITOR_SET](state, { questionId, questionType }) {
      // Allow to set questionId only If both values are available or nil
      if (questionId ? Boolean(questionType) : !questionType) {
        state.questionId = questionId;
      }
      state.questionType = questionType;
    },
    [questions.con.QUESTION_REPLACE_SELECTED_DEF](state, newDefinition) {
      state.selected = {
        ...state.selected,
        flowDefinition: newDefinition
      };
    }
  },
  actions: {
    async addQuestion({ commit, rootState }, owner) {
      commit(questions.con.QUESTION_SUBMIT_INIT);
      try {
        const { path, addToOwnerMutation, addLocation } = getOwnerData(
          rootState,
          owner
        );
        const ref = await questionsApi.add(path, addLocation);
        commit(addToOwnerMutation, ref, { root: true });
        commit(questions.con.QUESTION_CREATED, ref.id);
        commit(questions.con.QUESTION_SUBMIT_DONE);
      } catch (error) {
        commit(questions.con.QUESTION_SUBMIT_DONE);
        throw error;
      }
    },
    async updateQuestion({ commit, state }, data) {
      commit(questions.con.QUESTION_SUBMIT_INIT);
      try {
        await questionsApi.update(data, state.questionType);
        commit(questions.con.QUESTION_SUBMIT_DONE);
      } catch (error) {
        commit(questions.con.QUESTION_SUBMIT_DONE);
        throw error;
      }
    },
    async cloneQuestion({ commit }, questionId) {
      const otherQuestion = await questionsApi.get(questionId);
      commit(
        questions.con.QUESTION_REPLACE_SELECTED_DEF,
        otherQuestion.flowDefinition
      );
    },
    validateQuestion({ state }, data) {
      questionsApi.validate(data, state.questionType);
    }
  }
});

const hop = compose(
  canAdd(),
  canUpdate(),
  selectable(questionsApi)
);

export default hop(questions);
